import { useNavigate, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LogOut, Shield, ChevronDown, Building2 } from 'lucide-react'
import { useAuth } from '@/features/auth/AuthContext'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'

export function UserMenu() {
  const { t } = useTranslation()
  const { user, currentTenant, tenants, signOut, switchTenant, hasGlobalRole } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await signOut()
    navigate('/login')
  }

  const userInitial = (user?.user_metadata?.name?.[0] || user?.email?.[0] || '?').toUpperCase()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex items-center gap-2 px-2">
          <Avatar className="h-8 w-8">
            <AvatarFallback className="text-xs">{userInitial}</AvatarFallback>
          </Avatar>
          <ChevronDown className="h-4 w-4 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <div className="flex flex-col">
            <span className="text-sm">{user?.user_metadata?.name || user?.email}</span>
            {user?.user_metadata?.name && (
              <span className="text-xs text-muted-foreground font-normal">{user.email}</span>
            )}
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />

        {tenants.length > 1 && (
          <>
            <DropdownMenuLabel className="text-xs text-muted-foreground font-normal">
              {t('navigation.switchTenant')}
            </DropdownMenuLabel>
            {tenants.map((ut) => (
              <DropdownMenuItem
                key={ut.tenant_id}
                onClick={() => switchTenant(ut.tenant_id)}
                className={ut.tenant_id === currentTenant?.tenant_id ? 'bg-muted' : ''}
              >
                <Building2 className="mr-2 h-4 w-4" />
                {ut.tenant.name}
              </DropdownMenuItem>
            ))}
            <DropdownMenuSeparator />
          </>
        )}

        {hasGlobalRole('super_admin') && (
          <>
            <DropdownMenuItem asChild>
              <Link to="/admin">
                <Shield className="mr-2 h-4 w-4" />
                {t('navigation.administration')}
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}

        <DropdownMenuItem onClick={handleLogout}>
          <LogOut className="mr-2 h-4 w-4" />
          {t('auth.logout')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
